// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1NdrA","emails":"CreateEditClinics_emails__3hrn6","emailTagLabel":"CreateEditClinics_emailTagLabel__xyUDB"};